class ButtonStart implements ng.IComponentController {
    additionalClasses: string;
    buttons: anm.LandingButtonData[] | boolean;
    private defaultButtons: anm.LandingButtonData[] = [
        {
            title: 'signup-free',
            isLogin: false
        }, {
            title: 'create-video',
            isLogin: true
        }
    ];

    $onInit() {
        this.setButtons();
    }

    private setButtons() {
        if (!this.buttons) {
            return;
        }

        if (this.buttons === true) {
            this.buttons = this.defaultButtons;
        }

        const {waveEditorDomain, user} = options;

        const getUrl = (button: anm.LandingButtonData) => {
            const loginUrl = 'wave/my-templates';
            return button.isLogin ? loginUrl : 'wave/signup';
        };

        this.buttons = this.buttons.map((button: anm.LandingButtonData) => ({
            ...button,
            url: button.url || getUrl(button),
            show: user.anonymous && !button.isLogin || !user.anonymous && button.isLogin
        }))
    }
}

angular.module('animatronApp.buttonStart', []).component('buttonStart', {
    bindings: {
        additionalClasses: '@',
        buttons: '<'
    },
    controller: ButtonStart,
    template: `<a
                class="{{ $ctrl.additionalClasses }}"
                ng-repeat="button in $ctrl.buttons"
                ng-href="{{ button.url }}"
                ng-if="button.show"
        >{{::$root.t(button.title)}}</a>`
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/ButtonStart.ts